import { render, staticRenderFns } from "./workerEditTabInformation.vue?vue&type=template&id=5427a972&scoped=true&"
import script from "./workerEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./workerEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./workerEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427a972",
  null
  
)

export default component.exports